import * as React from 'react'
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import '../Profile/Profile.css';
export interface ProfileNavDesktopProperties {
    isPersonalDetails: boolean
}

class ProfileNavDesktop extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            hour: null,
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.getHour = this.getHour.bind(this);
    }

    componentDidMount() {
        this.getHour()
    }

    getHour = () => {
        const date = new Date();
        const hour = date.getHours()
        this.setState({
            hour
        });
    }

    render() {
        const { hour } = this.state;
        const { firebase, profile } = this.props;
        let defaultImage = "./Images/Avatar/male-robot.png"
        if (profile.gender === "F") {
            defaultImage = "./Images/Avatar/female-robot.png";
        }

        return (
            <>
                <div className="container">
                    <div className="pt-3">
                        <Image className="profile-image" src={(firebase.auth.photoURL) ? (firebase.auth.providerData[0].providerId === "facebook.com" ? firebase.auth.photoURL + "?type=normal" : firebase.auth.photoURL) : defaultImage} />
                        <span className="profile-camera d-none">
                            <Image src="./Images/icon-camera.svg" />
                        </span>
                    </div>
                    {
                        this.props.isPersonalDetails ?
                            <div className="container">
                                <div className="row mt-5 ml-5 ">
                                    <div className="col-7 text-right">
                                        <p className="mb-0">{hour < 12 ? 'Good morning' : (hour >= 12 && hour < 18) ? 'Good afternoon' : 'Good evening'}</p>
                                        <p className="profile-name">{profile.name} {profile.surname}</p>
                                        <hr />
                                    </div>
                                    <div className="col-5">
                                        <button className="btn btn-outline-red">Edit details</button>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="justify-content-center text-center mt-2">
                                <p className="mb-0">{hour < 12 ? 'Good morning' : (hour >= 12 && hour < 18) ? 'Good afternoon' : 'Good evening'}</p>
                                <h3 className="">{profile.name} {profile.surname}</h3>
                            </div>
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileNavDesktop);